import locale from "csi/locale";
import Delete from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const UnlinkAndDeleteThemeBOMController = declare(Delete, {

	/**
     * @override
     */
	confirmAction(params: any): void {
		const themeBOM = this.getContext().getNode();
		if (themeBOM.ThemeBOMLinkedStyleBOMs.length) {
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.title = locale.resource("UnlinkAndDeleteThemeBOM_Title");
			params.message = locale.resource("UnlinkAndDeleteThemeBOM_Confirm");
			this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;
		}

		this.inherited(arguments);
	},
});

export = UnlinkAndDeleteThemeBOMController;